import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function taskDeleteReducer(
	state = initialState.taskDeleteResponse,
	action
) {
	switch (action.type) {
		case types.DELETE_TASK:
			return typeof action.response === 'string' ||
				action.response instanceof String
				? action.response
				: '';
		case types.DELETE_TASKS:
			return typeof action.response === 'string' ||
				action.response instanceof String
				? action.response
				: '';
		case types.CLEAN_DELETE_TASK:
			return '';
		default:
			return state;
	}
}
